<script lang="ts">
    import {getOrCreateSearchManagerProxyContext} from './search-context';

    export const searchManagerProxy = getOrCreateSearchManagerProxyContext();
</script>

<slot {searchManagerProxy}/>